// Số thuế đề nghị hoàn điều chỉnh tăng/giảm:
export default {
  TaxRefundGTGT: 7551,
  LateRefund: 7552,
  TaxRefundConsume: 7553,
  TaxRefundImportCar: 7554,
  TaxRefundSupportingIndustry: 7555,
  OtherRefund: 7599,
};
